import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const SkillWeight = pgTable(
  'skill_weight',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    color: text().notNull(),
    iconUrl: text().notNull(),
    order: integer().notNull(),
    legacyCategoryId: integer(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('skill_weight_name_idx').on(columns.name),
    index('skill_weight_updated_at_idx').on(columns.updatedAt),
    index('skill_weight_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertSkillWeightSchema = createInsertSchema(SkillWeight)
export const UpdateSkillWeightSchema = createUpdateSchema(SkillWeight)
  .omit({ id: true, legacyCategoryId: true, legacyNeonTagId: true })
  .partial()
export const SelectSkillWeightSchema = createSelectSchema(SkillWeight)

export type InsertSkillWeight = typeof SkillWeight.$inferInsert
export type UpdateSkillWeight = z.infer<typeof UpdateSkillWeightSchema>
export type SelectSkillWeight = typeof SkillWeight.$inferSelect
